import React, { useEffect, useRef } from 'react';
import AccountNav from '../../components/AccountNav/AccountNav';
import AccountNavMobile from '../../components/AccountNavMobile/AccountNavMobile';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import './MarketPlace.scss';
import MarketHero from '../../components/MarketHero/MarketHero';
import MarketCard from '../../components/MarketCard/MarketCard';
import ResourcesCard from '../../components/ResourcesCard/ResourcesCard';
import OpeningBanner from '../../components/OpeningBanner/OpeningBanner';
import MarketFooter from '../../components/MarketFooter/MarketFooter';
import MarketSlider from '../../components/MarketSlider/MarketSlider';
import { fetchInitialOfferingListAction } from '../../store/reducer/initialOfferingSlice';
import { fetchSecondaryOfferingListAction } from '../../store/reducer/secondaryOfferingSlice';
import { Button } from 'antd'
import { toastNotify } from '../../utils/toastNotify'
import ListingAgreementNotification from '../../components/ListingAgreement/ListingAgreementNotification'
import ListingAgreement from '../../components/ListingAgreement/ListingAgreement'

const MarketPlace = () => {
  const shouldLog = useRef(true);
  const initialMarketpropertyList = useSelector((state) => state.initialOffering.sliderData);
  const loadingInitial = useSelector((state) => state.initialOffering.loading);
  const secondaryMarketPropertyList = useSelector((state) => state.secondaryOffering.sliderData);
  const loadingSecondary = useSelector((state) => state.secondaryOffering.loading);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const featchInitialOfferingData = async () => {
    const onFetchFail = () => {
      if (location?.state?.prevPath) {
        navigate(location.state.prevPath);
      }
      navigate(`/`);
    };
    await dispatch(fetchInitialOfferingListAction({ page: 1, perPage: 9, onFail: onFetchFail }));
  };

  const featchSecondaryOfferingData = async () => {
    await dispatch(fetchSecondaryOfferingListAction({ page: 1, perPage: 9 }));
  };

  useEffect(() => {
    if (shouldLog.current) {
      shouldLog.current = false;
      featchInitialOfferingData();
      featchSecondaryOfferingData();
    }
  }, []);
  return (
    <div className='marketplace'>
      <div className="sticky-nav">
        <AccountNav />
      </div>
      <div className="sticky-nav">
        <AccountNavMobile />
      </div>
      <MarketHero />
      <MarketCard />
      {/* === Check the notification implementation here === */}
      {/* <Button onClick={() => toastNotify('newAgreement', <ListingAgreementNotification onBtnClick={() => null} />)}>Click me</Button>
      <ListingAgreement /> */}
      {(loadingInitial || initialMarketpropertyList?.data?.properties?.length > 0) && (
        <MarketSlider
          market='Initial Offerings'
          marketLink='/marketplace/initial/'
          initialOfferingData={initialMarketpropertyList}
          initialLoading={loadingInitial}
          isSecondary={false}
        />
      )}
      {(loadingSecondary || secondaryMarketPropertyList?.data?.properties?.length > 0) && (
        <MarketSlider
          market={'Realbricks Market'}
          marketLink='/marketplace/secondary/'
          secondaryMarketData={secondaryMarketPropertyList}
          secondaryLoading={loadingSecondary}
          isSecondary={true}
        />
      )}
      {!loadingSecondary && (secondaryMarketPropertyList?.data?.properties?.length <= 0 || Object.keys(secondaryMarketPropertyList)?.length <= 0 ) && <OpeningBanner />}
      {/* Temporary comment as secondary market not lunched yet */}
      {/* <ResourcesCard /> */}
      <MarketFooter />
    </div>
  );
};

export default MarketPlace;
